// The collection query-building selectors that lived here died with their
// last consumer, the community members page's getInitialProps graph fetch
// (YD-12334); only the reducer's initial state shape remains.
export const initialValues = {
  isFetching: false,
  filters: {},
  page: 0,
  perPage: null,
  sortBy: null,
  isSortAscending: false,
  asof: Date.now(),
  lastFetchedState: {}
}
